module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/28.ee8d4efd.jpg";